var _g, _g2, _path, _path2, _g3, _g4, _g5, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFutoiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_20745_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 53C17 52.4477 17.4477 52 18 52H60C60.5523 52 61 52.4477 61 53V53.644C61 54.1981 60.8114 54.7357 60.4653 55.1684C59.5391 56.3261 58.137 57 56.6544 57H21.3456C19.863 57 18.4609 56.3261 17.5347 55.1684C17.1886 54.7357 17 54.1981 17 53.644V53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 53C17.5 52.7239 17.7239 52.5 18 52.5H60C60.2761 52.5 60.5 52.7239 60.5 53V53.644C60.5 54.0846 60.3501 54.512 60.0749 54.856C59.2436 55.8951 57.9851 56.5 56.6544 56.5H21.3456C20.0149 56.5 18.7564 55.8951 17.9251 54.856L17.5347 55.1684L17.9251 54.856C17.6499 54.512 17.5 54.0846 17.5 53.644V53Z",
    stroke: "url(#paint0_radial_20745_558)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_20745_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 29C21 26.7909 22.7909 25 25 25H53C55.2091 25 57 26.7909 57 29V49C57 50.1046 56.1046 51 55 51H23C21.8954 51 21 50.1046 21 49V29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 29C21.5 27.067 23.067 25.5 25 25.5H53C54.933 25.5 56.5 27.067 56.5 29V49C56.5 49.8284 55.8284 50.5 55 50.5H23C22.1716 50.5 21.5 49.8284 21.5 49V29Z",
    stroke: "url(#paint1_radial_20745_558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 29C21.5 27.067 23.067 25.5 25 25.5H53C54.933 25.5 56.5 27.067 56.5 29V49C56.5 49.8284 55.8284 50.5 55 50.5H23C22.1716 50.5 21.5 49.8284 21.5 49V29Z",
    stroke: "url(#paint2_radial_20745_558)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 29C21.5 27.067 23.067 25.5 25 25.5H53C54.933 25.5 56.5 27.067 56.5 29V49C56.5 49.8284 55.8284 50.5 55 50.5H23C22.1716 50.5 21.5 49.8284 21.5 49V29Z",
    stroke: "url(#paint3_radial_20745_558)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.604281 30.6678C0.213755 30.2772 0.213757 29.6441 0.604281 29.2536L12.2928 17.565C12.6834 17.1744 13.3165 17.1745 13.7071 17.565L25.388 29.246C25.7785 29.6365 25.7785 30.2697 25.3879 30.6602L21.878 34.1702C21.4874 34.5607 20.8543 34.5607 20.4637 34.1702L17.2418 30.9483C17.1327 30.8392 17.0504 30.7064 17.0012 30.5602L16.4419 28.8987C16.4057 28.7913 16.2469 28.8174 16.2471 28.9308L16.2695 40.8566C16.2705 41.4143 15.815 41.8652 15.2573 41.8584L13.0431 41.8314L10.7253 41.8517C10.1703 41.8566 9.71754 41.4086 9.71649 40.8536L9.69422 28.9693C9.69401 28.8545 9.53226 28.8304 9.49862 28.9401L9.03991 30.4355C8.99199 30.5917 8.90652 30.7338 8.79099 30.8493L5.49551 34.1448C5.10499 34.5353 4.47182 34.5353 4.0813 34.1448L0.604281 30.6678Z",
    fill: "#FFA300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5378 13.4743C40.9283 13.8648 40.9283 14.498 40.5378 14.8885L28.8492 26.5771C28.4587 26.9676 27.8256 26.9676 27.435 26.5771L15.7541 14.8961C15.3636 14.5056 15.3636 13.8724 15.7541 13.4819L19.2641 9.97191C19.6547 9.58138 20.2878 9.58138 20.6783 9.97191L23.9003 13.1938C24.0093 13.3029 24.0917 13.4357 24.1409 13.5819L24.7002 15.2434C24.7364 15.3508 24.8952 15.3247 24.895 15.2113L24.8726 3.28552C24.8716 2.72774 25.3271 2.27693 25.8848 2.28372L28.099 2.3107L30.4168 2.29036C30.9718 2.28549 31.4246 2.73347 31.4256 3.28845L31.4479 15.1728C31.4481 15.2875 31.6098 15.3116 31.6435 15.202L32.1022 13.7066C32.1501 13.5504 32.2356 13.4083 32.3511 13.2928L35.6466 9.9973C36.0371 9.60678 36.6703 9.60678 37.0608 9.9973L40.5378 13.4743Z",
    fill: "#FF0400"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_20745_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 53C17 52.4477 17.4477 52 18 52H60C60.5523 52 61 52.4477 61 53V53.644C61 54.1981 60.8114 54.7357 60.4653 55.1684C59.5391 56.3261 58.137 57 56.6544 57H21.3456C19.863 57 18.4609 56.3261 17.5347 55.1684C17.1886 54.7357 17 54.1981 17 53.644V53Z",
    fill: "url(#paint4_linear_20745_558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 53C17 52.4477 17.4477 52 18 52H60C60.5523 52 61 52.4477 61 53V53.644C61 54.1981 60.8114 54.7357 60.4653 55.1684C59.5391 56.3261 58.137 57 56.6544 57H21.3456C19.863 57 18.4609 56.3261 17.5347 55.1684C17.1886 54.7357 17 54.1981 17 53.644V53Z",
    fill: "url(#paint5_radial_20745_558)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 53C17.5 52.7239 17.7239 52.5 18 52.5H60C60.2761 52.5 60.5 52.7239 60.5 53V53.644C60.5 54.0846 60.3501 54.512 60.0749 54.856C59.2436 55.8951 57.9851 56.5 56.6544 56.5H21.3456C20.0149 56.5 18.7564 55.8951 17.9251 54.856L17.5347 55.1684L17.9251 54.856C17.6499 54.512 17.5 54.0846 17.5 53.644V53Z",
    stroke: "url(#paint6_radial_20745_558)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_20745_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 29C21 26.7909 22.7909 25 25 25H53C55.2091 25 57 26.7909 57 29V49C57 50.1046 56.1046 51 55 51H23C21.8954 51 21 50.1046 21 49V29Z",
    fill: "url(#paint7_linear_20745_558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 29C21 26.7909 22.7909 25 25 25H53C55.2091 25 57 26.7909 57 29V49C57 50.1046 56.1046 51 55 51H23C21.8954 51 21 50.1046 21 49V29Z",
    fill: "url(#paint8_radial_20745_558)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 29C21.5 27.067 23.067 25.5 25 25.5H53C54.933 25.5 56.5 27.067 56.5 29V49C56.5 49.8284 55.8284 50.5 55 50.5H23C22.1716 50.5 21.5 49.8284 21.5 49V29Z",
    stroke: "url(#paint9_radial_20745_558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 29C21.5 27.067 23.067 25.5 25 25.5H53C54.933 25.5 56.5 27.067 56.5 29V49C56.5 49.8284 55.8284 50.5 55 50.5H23C22.1716 50.5 21.5 49.8284 21.5 49V29Z",
    stroke: "url(#paint10_radial_20745_558)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 29C21.5 27.067 23.067 25.5 25 25.5H53C54.933 25.5 56.5 27.067 56.5 29V49C56.5 49.8284 55.8284 50.5 55 50.5H23C22.1716 50.5 21.5 49.8284 21.5 49V29Z",
    stroke: "url(#paint11_radial_20745_558)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_20745_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 53C17 52.4477 17.4477 52 18 52H60C60.5523 52 61 52.4477 61 53V53.644C61 54.1981 60.8114 54.7357 60.4653 55.1684C59.5391 56.3261 58.137 57 56.6544 57H21.3456C19.863 57 18.4609 56.3261 17.5347 55.1684C17.1886 54.7357 17 54.1981 17 53.644V53Z",
    fill: "url(#paint12_linear_20745_558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 53C17 52.4477 17.4477 52 18 52H60C60.5523 52 61 52.4477 61 53V53.644C61 54.1981 60.8114 54.7357 60.4653 55.1684C59.5391 56.3261 58.137 57 56.6544 57H21.3456C19.863 57 18.4609 56.3261 17.5347 55.1684C17.1886 54.7357 17 54.1981 17 53.644V53Z",
    fill: "url(#paint13_radial_20745_558)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 53C17.5 52.7239 17.7239 52.5 18 52.5H60C60.2761 52.5 60.5 52.7239 60.5 53V53.644C60.5 54.0846 60.3501 54.512 60.0749 54.856C59.2436 55.8951 57.9851 56.5 56.6544 56.5H21.3456C20.0149 56.5 18.7564 55.8951 17.9251 54.856L17.5347 55.1684L17.9251 54.856C17.6499 54.512 17.5 54.0846 17.5 53.644V53Z",
    stroke: "url(#paint14_radial_20745_558)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 30C51.1046 30 52 30.8954 52 32C52 33.1046 51.1046 34 50 34L26 34C25.4477 34 25 33.5523 25 33L25 31C25 30.4477 25.4477 30 26 30L50 30Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 42C51.1046 42 52 42.8954 52 44C52 45.1046 51.1046 46 50 46L26 46C25.4477 46 25 45.5523 25 45L25 43C25 42.4477 25.4477 42 26 42L50 42Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36C51.1046 36 52 36.8954 52 38C52 39.1046 51.1046 40 50 40L26 40C25.4477 40 25 39.5523 25 39L25 37C25 36.4477 25.4477 36 26 36L50 36Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29C52.1046 29 53 29.8954 53 31C53 32.1046 52.1046 33 51 33L27 33C26.4477 33 26 32.5523 26 32L26 30C26 29.4477 26.4477 29 27 29L51 29Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41C52.1046 41 53 41.8954 53 43C53 44.1046 52.1046 45 51 45L27 45C26.4477 45 26 44.5523 26 44L26 42C26 41.4477 26.4477 41 27 41L51 41Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35C52.1046 35 53 35.8954 53 37C53 38.1046 52.1046 39 51 39L27 39C26.4477 39 26 38.5523 26 38L26 36C26 35.4477 26.4477 35 27 35L51 35Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_20745_558",
    x: 9,
    y: 44,
    width: 60,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_20745_558",
    x: 13,
    y: 17,
    width: 52,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_20745_558",
    x: 9,
    y: 44,
    width: 60,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_20745_558",
    x: 13,
    y: 17,
    width: 52,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_20745_558",
    x: 9,
    y: 44,
    width: 60,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20745_558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20745_558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 52) rotate(90) scale(3.75 17.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 41.9722) rotate(4.42478) scale(14.0419 10.1967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5 29.6944) rotate(144.162) scale(5.5509 23.2933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5 30.0556) rotate(124.695) scale(13.1762 15.4161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20745_558",
    x1: 17,
    y1: 52,
    x2: 17.354,
    y2: 58.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17 52) scale(44 5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 52) rotate(90) scale(3.75 17.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_20745_558",
    x1: 21,
    y1: 25,
    x2: 31.3823,
    y2: 53.7509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.11
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21 25) scale(36 26)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 41.9722) rotate(4.42478) scale(14.0419 10.1967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5 29.6944) rotate(144.162) scale(5.5509 23.2933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5 30.0556) rotate(124.695) scale(13.1762 15.4161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_20745_558",
    x1: 17,
    y1: 52,
    x2: 17.354,
    y2: 58.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17 52) scale(44 5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_20745_558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 52) rotate(90) scale(3.75 17.8593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutoiLogo);
export default __webpack_public_path__ + "static/media/futoiLogo.8cb93bdaacd85563622da1122f3c2d95.svg";
export { ForwardRef as ReactComponent };